import { Component, Inject, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { TrnxCommonTs } from './../../shared/common/trnxCommonTs';
import { Actionbutton } from './../../shared/common/Actionbutton';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportlinksserviceService } from './../reportlinks/reportlinksservice.service';
import { ErrorMessages } from './../../shared/common/errormessages';
import { constants } from './../../shared/common/contants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportingServiceService } from './../../shared/services/reporting-service.service';
import { validationmethod } from './../../shared/Validations/Validationmethods';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';

export interface VaultObjectData {
  data: any;
}
@Component({
    selector: 'app-vaultobjectgroupchild',
    templateUrl: './vaultobjectgroupchild.component.html',
    styleUrls: ['./vaultobjectgroupchild.component.scss'],
    standalone: false
})
export class VaultobjectgroupchildComponent implements OnInit {

  validations_form: UntypedFormGroup;
  ObjectGrid:any;
  paramstemp;
  ObjectsData:any=[];
  vaultGroup:any=[]
  columnDefsForObjects;
  reportCreationData={"description":"", "groupname":"",objectid: []}
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any= [];
  temp: any = [];
  selectedTableFields: any;
  gridApi;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen="";
  buttonColor="";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean= false;
  // columnDefs;
  retrieveObject: any = [];
  setObject:any=[];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";

  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName:any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  groupName:any;
  objectData: any=[];
  updateData:any;
  objectGroupData: any = [];
  allData:any = [];
  value;


  constructor(private dialogref: MatDialogRef<VaultobjectgroupchildComponent>,private validation: validationmethod,private service: ReportingServiceService,private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,private constants: constants,private msg: ErrorMessages,private fb: UntypedFormBuilder,private linkservice: ReportlinksserviceService,private localStorageSettings: LocalStorageSettingsService,private vaultObjectService: VaultObjectgroupService, private trnxCommonTs: TrnxCommonTs,private commonService:CommonService,@Inject(MAT_DIALOG_DATA) public data: VaultObjectData,) {
    this.validation_messages = this.msg.reportConfiguration;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      groupname:new UntypedFormControl('',[Validators.required,this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
      description:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
    });
  }

  ngOnInit() {

    console.log(this.data)
    this.updateData = this.data;
    console.log(this.updateData.data)
    console.log(this.updateData.data.rowData.description)
    this.reportCreationData.description=this.updateData.data.rowData.description;
    this.reportCreationData.groupname=this.updateData.data.rowData.objectGroupName;
    console.log(this.updateData.data.rowData.objectGroupId);
    this.vaultObjectService.retrieveobjects(this.updateData.data.rowData.objectGroupId).subscribe(result=> {
      console.log(result)
      this.allData = result;
      console.log(this.allData);
      for(let i=0;i<this.allData.length;i++){
        this.reportCreationData.objectid.push(this.allData[i].objectId)


      //this.reportCreationData.objectid.push({objectid: this.allData[i].objectId })


      }
      this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.allData);
    });
    this.validations_form = this.fb.group({
      groupname: '',
      description: ''
    });

    // this.lookupVaultGroup();

    this.columnDefsForObjects = [
      {
        headerName: "Vault Objects",
        headerTooltip: "Vault Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Objects",
        headerTooltip: "Selected  Objects",
        tooltipValueGetter: params => "Selected  Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // save and update button toggle
    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
    console.log(this.buttonName);

    this.formValidationsCheckbox();
    this.formValidation();


  }

  selectcheckedfield() {
    console.log(this.ObjectGrid.api)
    for(let o=0; o<this.allData.length; o++){
      console.log(this.allData[0]);
    this.ObjectGrid.api.forEachNode(node=> {
      if(node.data.objectlabel===this.allData[o].objectlabel){
        node.setSelected(true);
        this.temp.push(this.allData[o])
        // this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
      }
    });
  }
  }



  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.linkservice.retrievereportlinks().subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        // for(let i=0;i<this.getdata.length;i++){
        //   console.log(this.getdata[i].objectlabel)
        //   console.log(this.updateData.data.rowData.objectlabel)
        //   if(this.getdata[i].objectlabel===this.updateData.data.rowData.objectlabel){
        //     this.rowbindingdata.api.setSelected(true,true);
        //   }
        // }
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)
      }
      this.spinner.stop();
    });
  }

 async onGridReadyForObjects(params){
  this.tableFields=[];
  this.selectedObjects=[];
  this.ObjectGrid=params;
  this.spinner.start();
  let tableName="objectmetadata";
  let response=await  this.commonService.retrieveRecordService(tableName);
  //this.ObjectGrid.api.setGridOption('rowData', response);
  if(tableName === undefined){
        this.ObjectGrid.api.setGridOption('rowData', []);
      }else{
      this.tablefields = response;
      console.log(this.tablefields)
      this.gridApiForTablesFields = params;
      this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
      //this.selectedObjects.api.setGridOption('rowData', []);
      }
      //this.gridApiForTablesFields.setGridOption('rowData', response);
      this.selectcheckedfield()

      //this.gridApiForTablesFields = params.api;

}


  onRowSelected(event) {
   console.log(this.fieldsData)
    this.fieldsData = this.ObjectGrid.api.getSelectedRows();

    this.selectedObjects = this.fieldsData;
    this.selectedObjects = this.selectedObjects.filter((obj, index, array) => {
      return array.findIndex((o) => o.objectlabel === obj.objectlabel) === index;
    });
    console.log(this.selectedObjects);
}

   onGridReadyForSelectedTableFields(params,data) {
    this.selectedTableFields=params
    this.selectedFieldsDataToPush=data;
    console.log(data);
    this.selectedTableFields.api.setGridOption('rowData', data);

  }

   //forward Icon Function decleation
   pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.selectedObjects);
    this.selectedObjects = this.selectedObjects.filter((obj, index, array) => {
      return array.findIndex((o) => o.objectlabel === obj.objectlabel) === index;
    });
    console.log(this.selectedObjects)
    for (let i = 0; i < this.selectedObjects.length; i++) {
      // let tempobj = this.reportCreationData.objectid.filter(item => item.objectid ==this.selectObjectId[i].id);
      // if(tempobj.length <= 0){
      //   this.reportCreationData.objectid.push({objectud:this.selectedObjects[i].id})
      // }
      if(!this.reportCreationData.objectid.includes(this.selectedObjects[i].id)){
        this.reportCreationData.objectid.push(this.selectedObjects[i].id)
      }

    }
    console.log(this.reportCreationData)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedObjects.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  }

  //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.tablefields);
    for (let i = 0; i < this.tablefields.length; i++) {
      if(!this.reportCreationData.objectid.includes(this.tablefields[i].id)){
      console.log(this.tablefields[i].id)

     this.reportCreationData.objectid.push(this.tablefields[i].id)
      }
    }

    // //duplicates data not allowed
   this.temp = this.tablefields.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
        console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.pushDataToSelectedFieldsGrid();
    this.ObjectGrid.api.forEachNode(node=>{

      node.setSelected(true)

})
  }

  //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedObjects.length = 0
    this.temp.length = 0
    this.temp=[]
    this.reportCreationData.objectid=[]
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,null)
    // this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.ObjectGrid.api.forEachNode(node=>{

           node.setSelected(false)

    })
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    console.log(this.temp)
    this.temp = this.temp.filter((obj, index, array) => {
      return array.findIndex((o) => o.id === obj.id) === index;
    });

    let objectIds = this.reportCreationData.objectid
    console.log(objectIds)
    console.log(this.fieldsDataToRemove)
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
   // this.selectedTableFields = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
   for(let o=0;o<this.fieldsDataToRemove.length;o++){
    this.ObjectGrid.api.forEachNode(node=>{
      if(node.data.objectlabel===this.fieldsDataToRemove[o].objectlabel){
           node.setSelected(false)
      }
    })
  }
  const objectIdToRemove = this.fieldsDataToRemove.map(obj => obj.objectId);
  console.log(objectIdToRemove)
  console.log(this.reportCreationData)
  this.reportCreationData.objectid = objectIds.filter(num => !objectIdToRemove.includes(num));
 console.log(this.reportCreationData.objectid)
 console.log(this.reportCreationData)
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    console.log(this.selectedTableFields.api)
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }

  save(){
    console.log(this.reportCreationData);
        this.spinner.start();
        this.reportCreationData.objectid = this.reportCreationData.objectid.map(objectid => ({ objectid }));
    this.vaultObjectService.updateObjects(this.updateData.data.rowData.objectGroupId,this.reportCreationData).subscribe(response => {
      // this.spinner.start();
       console.log(response)
        // checking if response is true or not
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.spinner.stop();
        this.cancel();
      }
      // this.spinner.stop();
      // this.onGridReady(this.rowbindingdata);

      // console.log(this.isCheckboxSelected);
      // // this.isCheckboxSelected = true;
      // if (this.isCheckboxSelected == true){
      //   this.validations_form.reset();
      // }
      // else{
      //   this.dialogref.close();
      //   this.cancel();
        // this.reportCreationDuplicate.push(response);
        // this.spinner.start();
      // }
      this.spinner.stop();

    });
  // this.cancel();

  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }

  // async next(value) {
  //   console.log(value)
  //   // checking the form is valid or not while insert
  //   if (!this.formValid.valid) {

  //     // displaying validation messages

  //     this.validation.validateAllFormFields(this.formValid);

  //     this.validation.getvalidationmessage();

  //   }
  // }

  close(){
    console.log(this.isCheckboxSelected);
    console.log(typeof this.isCheckboxSelected);
    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.validations_form.reset();
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      // this.reportCreationData = [];

      this.dialogref.close();

    }
  }
  cancel() {
  // this.formValidCheckbox.reset();
  // this.formValidationsCheckbox();
  this.isCheckboxSelected = false;
   this.reportCreationData= {
    description: "",
    groupname: "",
   objectid: [],
   }
   this.dialogref.close();

   this.close();
  //  window.location.reload();
  }


}
